import React, { useEffect, useState } from "react";
import {
  Badge,
  Dropdown,
  Menu,
  List,
  Typography,
  Button,
  Divider,
  Tag,
  Modal,
  message,
} from "antd";
import {
  BellFilled,
  BellOutlined,
  CheckOutlined,
  CloseOutlined,
} from "@ant-design/icons";
import useAxios from "../hooks/useAxios";
import useNotification from "../hooks/useNotification";
import { ReactLoading } from "../pages/Dashboard/TinManagement/import";

const { Text } = Typography;

const NotificationBell = () => {
  const api = useAxios();
  const { notifications, getNotifications, userNotifications } =
    useNotification();
  const [modal, setModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [reason, setReason] = useState("");
  const [reasonError, setReasonError] = useState("");
  const [visible, setVisible] = useState(false);
  const [selectedId, setSelectedId] = useState(null);

  const unreadCount =
    (notifications?.length || 0) +
    (userNotifications?.filter((ele) => ele?.status === null)?.length || 0);

  const acceptRejectRequest = async (id, status) => {
    if (!status && !reason?.trim()) {
      return setReasonError("Reason is required");
    }
    try {
      setLoading(true);
      await api.put(
        `/tinApproval/${id}`,
        {
          status,
          remarks: reason,
        },
        {
          tokenType: "user",
        },
      );
      await getNotifications();
      if (!status) {
        setReason("");
        setSelectedId(null);
        setModal(false);
        setVisible(false);
        setReasonError("");
        message.success("Request rejected.");
        return;
      }

      message.success("Request accepted.");
    } catch (err) {
      console.error(err);
      message.error(err?.response?.data?.message || "Something went wrong.");
    } finally {
      setLoading(false);
    }
  };

  const menu = (
    <div
      style={{
        width: 350,
        maxHeight: 400,
        overflowY: "auto",
        background: "#fff",
        boxShadow: "0 3px 6px rgba(0,0,0,0.15)",
        borderRadius: 4,
      }}
      onClick={(e) => e.stopPropagation()}
    >
      {notifications.length === 0 && userNotifications.length === 0 && (
        <div style={{ padding: 20, textAlign: "center" }}>No Notifications</div>
      )}

      {notifications.map((item) => (
        <div
          key={item._id}
          style={{
            padding: 16,
            borderBottom: "1px solid #f0f0f0",
            background: item.status === null ? "#f0f5ff" : "#ffffff",
          }}
        >
          <p>
            The below mentioned {item?.requestByuserDetails?.role} has requested
            for a new TIN that requires your approval.
          </p>

          <Text strong>
            Requested By: {item?.requestByuserDetails?.name} (
            {item?.requestByuserDetails?.role})
          </Text>
          <br />
          <Text>Candidate: {item?.candidateDetails?.name}</Text>
          <br />
          <Text>Test Attempt: {item?.attemptCount}</Text>
          <br />
          <Text>Remarks: {item?.requestRemarks || "NA"}</Text>

          <Divider style={{ margin: "10px 0" }} />

          {item.status === null ? (
            <div style={{ display: "flex", gap: 8 }}>
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  acceptRejectRequest(item._id, true);
                }}
                className="__btn px-3 text-white rounded font-weight-bold __initial_accepted"
              >
                <CheckOutlined style={{ marginRight: 5 }} />
                Accept
              </button>

              <button
                onClick={(e) => {
                  e.stopPropagation();
                  setSelectedId(item._id);
                  setVisible(true);
                  setModal(true);
                }}
                className="__btn px-3 text-white rounded font-weight-bold __initial_rejected"
              >
                <CloseOutlined style={{ marginRight: 5 }} />
                Reject
              </button>
            </div>
          ) : (
            <Tag color={item.status === true ? "green" : "red"}>
              {item.status ? "Approved" : "Rejected"}
            </Tag>
          )}
        </div>
      ))}

      {userNotifications.map((item) => {
        return (
          <div
            key={item._id}
            style={{
              padding: 16,
              borderBottom: "1px solid #f0f0f0",
              background: item.status === null ? "#f0f5ff" : "#ffffff",
            }}
          >
            <p>
              Your request for an additional TIN ({item?.attemptCount} attempt)
              has been{" "}
              {item.status === null
                ? "pending"
                : item.status
                  ? "approved"
                  : "rejected"}
              .
            </p>
            {item.status !== null && (
              <Text strong>
                {item.status ? "Approved By:" : "Rejected By:"}{" "}
                {item?.approvedByuserDetails?.name} (
                {item?.approvedByuserDetails?.role})
              </Text>
            )}
            <br />
            <Text>Candidate: {item?.candidateDetails?.name}</Text>
            <br />
            <Text>Remarks: {item?.requestRemarks || "NA"}</Text>
          </div>
        );
      })}
    </div>
  );

  const close = () => {
    setModal(false);
    setReason("");
    setReasonError("");
  };

  return (
    <>
      {loading && (
        <ReactLoading type="spin" color="#0000FF" className="spinnerBg" />
      )}
      <Dropdown
        visible={visible}
        onVisibleChange={(flag) => {
          if (!modal) {
            setVisible(flag);
          }
        }}
        overlay={menu}
        trigger={["click"]}
        placement="bottomRight"
      >
        <span style={{ cursor: "pointer" }}>
          <Badge count={unreadCount} size="small">
            <BellOutlined style={{ fontSize: 22 }} />
          </Badge>
        </span>
      </Dropdown>
      <Modal
        title=""
        zIndex={9991}
        className="p-0 custom_modal__"
        centered
        open={modal}
        width={500}
        closeIcon={
          <CloseOutlined style={{ color: "white", fontSize: "16px" }} />
        }
        footer={null}
        onCancel={() => {
          close();
        }}
      >
        <div>
          <div className="modal-header d-flex justify-content-between align-items-center active-color-modal text-white w-100">
            <h5
              className="modal-title text-white text-capitalize font-weight-bold"
              style={{ fontSize: "18px", fontWeight: 400 }}
            >
              Reason
            </h5>
          </div>
          <div className="row py-3 px-4 ">
            <div className="w-100">
              <div className="col-12 p-2">
                <div className="d-flex __custom_row">
                  <div style={{ flex: "1 1" }}>
                    <div>
                      <div className="form-group col-md-12 form-builder-element">
                        <label>Reason</label>
                        <textarea
                          placeholder="Type your reason"
                          className="border form-control"
                          onChange={(e) => setReason(e.target.value)}
                          value={reason}
                        ></textarea>
                        {reasonError && (
                          <p className="text-red-500">{reasonError}</p>
                        )}
                      </div>
                      <div className="form-group col-md-12 form-builder-element">
                        <button
                          onClick={(e) =>
                            acceptRejectRequest(selectedId, false)
                          }
                          className="btn btn-primary"
                        >
                          Save
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default NotificationBell;
